<template>
  <b-col sm="12" :lg="lgSize">
    <b-card class="state" header="Received">
      <Modal
        title="Choose period"
        class="modal-primary"
        v-model="stateModal"
        @on-ok="fetchStateReport(), (stateModal = false)"
        :transfer="false"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <!--          <b-form-input v-model="stateDateFrom" type="date" id="date"></b-form-input>-->
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="stateDateFrom"
              name="stateDateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="yyyy-MM-dd"
              :bootstrap-styling="true"
              v-model="stateDateTo"
              name="stateDateTo"
            ></datepicker>
            <!--          <b-form-input v-model="stateDateTo" type="date" id="dateTo"></b-form-input>-->
          </b-form-group>
        </b-form>
      </Modal>
      <div slot="header">
        <h5 style="display: inline;" class="card-title mb-0">
          Region Overview &nbsp&nbsp
          <small>
            {{ from ? from : stateDateFrom }}
            <b>|</b>
            {{ to ? to : stateDateTo }}
          </small>
        </h5>
        <!--            Central Division spent rate (by the state)-->
        <div class="card-header-actions">
          <b-button
            @click="stateModalEvent"
            class
            style="height: 26px; width: 26px"
            variant="transparent p-0"
          >
            <i class="icon-calendar" style="color: #20a8d8;"></i>
          </b-button>
          <b-button
            @click="toggleFullScreenState"
            style="height: 26px; width: 26px"
            class="float-right"
            variant="transparent p-0"
            right
          >
            <i style="color: #20a8d8;" class="icon-frame"></i>
          </b-button>
          <!--              <b-button @click="stateModal=true" class="float-right" variant="transparent p-0" right>-->
          <!--                <i class="icon-calendar"></i>-->
          <!--              </b-button>-->
        </div>
      </div>
      <!-- <div style="width: 100%; display: flex; justify-content: flex-start; margin-bottom:5px; ">
        <span style="line-height:30px; margin-right:22px">Select Models:  </span>
           <b-form-select
            v-model="selected"
            :options="options"
            style="width:140px"
            value-field="item"
            @change="this.fetchStateReport"
            text-field="name"
          ></b-form-select>
      </div> -->
      <div
        style="width: 100%; display: flex; justify-content: flex-end; margin-top: 0px"
      >
        <h5>Quantity</h5>
        <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5>
      </div>
      <div class="chart-wrapper">
        <div
          style="height: 400px; padding-top: 150px"
          v-if="loadingState"
          class="loading"
        >
          <b-row>
            <b-col lg="12">
              <div class="sk-double-bounce">
                <div class="sk-child sk-double-bounce1"></div>
                <div class="sk-child sk-double-bounce2"></div>
              </div>
            </b-col>
          </b-row>
          <!--/.row-->
        </div>
        <div v-else>
          <highmaps
            style="height: 100%"
            ref="stateRef"
            :options="optionsMap"
          ></highmaps>
        </div>
        <!--           <highcharts v-else :options="chartOptions" class="chart" :constructor-type="'chart'" ></highcharts>&ndash;&gt;-->
      </div>
      <Modal
        size="lg"
        :title="selectedStateName"
        class="modal-primary cities"
        @on-ok="fetchChartStateDetails()"
        v-model="stateChartModal"
        :transfer="false"
      >
        <div class="checkbox" style="float: right">
          <label>
            <input
              v-model="selectAll"
              type="checkbox"
              :checked="true"
              class="form-check-input"
              name="foo"
            />
            Select All
          </label>
        </div>
        <br />
        <div class="modal-body">
          <div class="chart-wrapper">
            <div
              style="height: 400px; padding-top: 150px"
              v-if="StateChartDetails"
              class="loading"
            >
              <b-row>
                <b-col lg="12">
                  <div class="sk-double-bounce">
                    <div class="sk-child sk-double-bounce1"></div>
                    <div class="sk-child sk-double-bounce2"></div>
                  </div>
                </b-col>
              </b-row>
              <!--/.row-->
            </div>
            <div v-else class="row">
              <!-- <div
                v-for="item in modalData"
                v-model="checkData"
                class="col-6 col-sm-6 col-md-4 col-xl-4 col-lg-4"
              >
                <div class="checkbox">
                  <label>
                    <input
                      v-model="selectedModalLocations"
                      type="checkbox"
                      :checked="true"
                      class="form-check-input"
                      name="foo"
                      :value="item.id"
                    />
                    {{item.fLoct}}
                  </label>
                </div>
              </div> -->
              <br />
            </div>
          </div>
          <br />
        </div>
      </Modal>
    </b-card>
  </b-col>
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import Highcharts from "highcharts-vue";
import iView from "iview";
import Datepicker from "vuejs-datepicker";
import router from "../router";
import usAll from "../views/base/usAll";

export default {
  name: "RegionOverview",
  components: {
    router,
    Highcharts,
    usAll,
    Datepicker,
    iView,
    cSwitch
  },
  props: ["lgSize"],
  data: function() {
    return {
      selectedStateName: "",
      selected: "All",
      options: [
        { item: "All", name: "All" },
        { item: "XM2", name: "XM2" },
        { item: "XM3", name: "XM3" }
      ],
      value: [20, 50],
      selectedCompany: "All",
      loadingState: false,
      valueQuantity: false,
      visible: false,
      selectAll: true,
      stateChartModal: false,
      stateDateFrom: "",
      stateDateTo: "",
      checkData: [],
      modalData: [],
      stateModal: false,
      fullscreenState: false,
      StateChartDetails: false,
      selectedModalLocations: [],
      optionsMap: {
        tooltip: {
          formatter: function() {
            return this.point.name + ": " + this.point.sign;
          }
        },
        chart: {
          map: usAll,
          backgroundColor: "transparent"
        },
        title: {
          text: ""
        },
        plotOptions: {
          map: {
            states: {
              hover: {
                color: "#EEDD66"
              }
            }
          },
          series: {
            stacking: "normal",
            point: {
              events: {
                click: ({ point }) => {
                  // console.log(point)
                  // this.toggleFullScreenState()
                  console.log(point.code);
                  // router.push(
                  //   "/base/MapByState/?state=" +
                  //     point.code +
                  //     "&date_from=" +
                  //     this.stateDateFrom +
                  //     "&date_to=" +
                  //     this.stateDateTo
                  // );
                  this.$refs.stateRef.chart.reflow();
                  this.selectedState = point.code;
                  // if (!this.valueQuantity) {
                  //   this.selectedStateName =
                  //     "Shipped to " +
                  //     point.name +
                  //     " - " +
                  //     point.value +
                  //     " Units";
                  // } else {
                  //   this.selectedStateName =
                  //     "Shipped to " + point.name + " - $" + point.value + "";
                  // }
                  // this.stateChartModal = true;
                  // this.fetchStateChartDetailsModal();
                  router.push(
                    "/base/MapByState/?state=" +
                      point.code +
                      "&date_from=" +
                      this.stateDateFrom +
                      "&date_to=" +
                      this.stateDateTo +
                      "&locations=" +
                      this.selectedModalLocations
                  );
                  // router.push('/base/Tables/?location=' + point.category + '&productGroup=&type=top&date_from=' + this.topLocationsDateFrom + '&date_to=' + this.topLocationsDateTo)
                }
              }
            }
          }
        },
        subtitle: {
          // text: 'Source map: <a href="http://code.highcharts.com/mapdata/countries/us/us-md-all.js">Maryland</a>'
          text: ""
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            verticalAlign: "bottom"
          }
        },
        colorAxis: {
          min: 0
        },
        series: [
          {
            mapData: usAll,
            data: this.data,
            joinBy: ["postal-code", "code"],
            name: "USA",
            color: "blue",
            states: {
              hover: {
                color: "#BADA55"
              }
            },
            dataLabels: {
              enabled: true,
              format: "{point.name}"
            }
          }
        ]
      }
    };
  },
  computed: {
    from() {
      if (typeof this.stateDateFrom === "object") {
        this.stateDateFrom = this.stateDateFrom.toISOString().split("T")[0];
        return this.stateDateFrom;
      }
    },
    to() {
      if (typeof this.stateDateTo === "object") {
        this.stateDateTo = this.stateDateTo.toISOString().split("T")[0];
        return this.stateDateTo;
      }
    }
  },
  watch: {
    selectAll(value) {
      if (!value) {
        this.selectedModalLocations = [];
      } else {
        this.modalData.forEach((value, index) => {
          this.selectedModalLocations.push(value.id);
        });
      }
    },
    receivedLocation(value) {
      // alert(value)
    },
    valueQuantity(value) {
      this.fetchStateReport();
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
    },

    fetchStateReport() {
      this.loadingState = true;
      let params = {};

      params = {
        date_from: this.stateDateFrom,
        date_to: this.stateDateTo,
        value: this.valueQuantity,
        // alpha: this.selected,
        company: this.selectedCompany
      };
      this.$http.get("api/atx/maps/stateReport.php", { params }).then(
        res => {
          this.data = res.data.records;
          this.data1 = this.data;
          this.optionsMap.series[0].data = this.data1;
          // console.log(this.data)
          this.loadingState = false;
          setTimeout(() => {
            if (this.fullscreenState) {
              this.$refs.stateRef.chart.options.chart.height = "50%";
            } else {
              this.$refs.stateRef.chart.options.chart.height = 400;
            }
            this.$refs.stateRef.chart.reflow();
          });
        },
        err => {
          console.log(err);
          this.loadingState = false;
        }
      );
    },

    fetchStateChartDetailsModal() {
      this.StateChartDetails = true;
      let finType = "fin";
      if (!this.valueQuantity) {
        finType = "qty";
      }
      let params = {};
      params = {
        type: finType,
        state: this.selectedState,
        date_from: this.stateDateFrom,
        date_to: this.stateDateTo
      };
      this.$http
        .get("api/atx/charts/locations_modal.php", {
          params
        })
        .then(
          res => {
            this.modalData = res.data.records;
            this.modalData.forEach((value, index) => {
              this.selectedModalLocations.push(value.id);
            });

            this.StateChartDetails = false;
          },
          err => {
            console.log(err);
            this.StateChartDetails = false;
          }
        );
    },
    fetchChartStateDetails() {
      if (this.selectedModalProductGroup === "All product groups") {
        this.selectedModalProductGroup = "";
      }
      if (typeof this.stateDateFrom === "object") {
        this.stateDateFrom = this.stateDateFrom.toISOString().split("T")[0];
      }
      if (typeof this.stateDateTo === "object") {
        this.stateDateTo = this.stateDateTo.toISOString().split("T")[0];
      }
      if (this.selectedModalLocations.length < 1) {
        alert("You must select at least one location ! ");
      } else {
        router.push(
          "/base/MapByState/?state=" +
            this.selectedState +
            "&date_from=" +
            this.stateDateFrom +
            "&date_to=" +
            this.stateDateTo +
            "&locations=" +
            this.selectedModalLocations
        );
      }
    },
    stateModalEvent() {
      if (this.fullscreenState) {
        // this.toggleFullScreenState();
        this.stateModal = 1;
      } else {
        this.stateModal = 1;
      }
    },
    toggleFullScreenState() {
      this.$fullscreen.toggle(this.$el.querySelector(".state"), {
        wrap: false,
        callback: this.fullscreenChangeState
      });
    },
    fullscreenChangeState(fullscreenState) {
      this.fullscreenState = fullscreenState;
      console.log("markan", this.$refs.stateRef);
      if (this.fullscreenState) {
        this.$refs.stateRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.stateRef.chart.options.chart.height = 400;
      }
      this.$refs.stateRef.chart.reflow();
    }
  },
  mounted() {
    if (!localStorage.getItem("atx_user")) {
      router.push("/pages/login/");
    }
    this.locationsIds = localStorage.getItem("locations");

    this.valueQuantity = false;

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.stateDateFrom = fromDate.toJSON().slice(0, 10);
    this.stateDateTo = new Date().toJSON().slice(0, 10);
    this.fetchStateReport();
  }
};
</script>
<style>
.ivu-modal-content {
  background: #3a4149 !important;
}
.cities .ivu-modal {
  width: 660px !important;
}
.ivu-modal-header p,
.ivu-modal-header-inner {
  color: white !important;
  font-size: 1.09375rem;
  font-weight: 500;
}
.ivu-modal-header {
  border-bottom: 1px solid #23282c !important;
  padding: 1rem;
}
.ivu-btn-text {
  color: #23282c;
  background-color: #acb5bc;
  border-color: #a5aeb7;
}
</style>
